export default __webpack_public_path__ + "static/media/yabe_logo.f2f74579.png";